import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';
import NiaLogo from '../../static/img/logo.webp';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
  },
  header: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(5),
    [theme.breakpoints.up(800 + theme.spacing(3 * 2))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(5),
    },
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(10),
    [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  niaLogoContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: theme.spacing(4),
  },
  link: {
    color: theme.palette.secondary.main,
    textDecoration: 'none',
  },
  text: {
    paddingBottom: theme.spacing(),
  },
});

const ContactPage = (props) => {
  const { classes } = props;
  return (
    <div className={classes.page}>
      <NavBar />
      <main className={classes.container}>
        <div className={classes.appBarSpacer} />
        <div className={classes.content}>
          <Typography className={classes.header} color="textSecondary" variant="h4">Contact Us</Typography>
          <Paper className={classes.paper} elevation={1}>
            <div className={classes.niaLogoContainer}>
              <img src={NiaLogo} className={classes.niaLogo} alt="Nia" />
            </div>
            <Typography variant="subtitle1" className={classes.text}><strong>Hours:</strong> Monday-Friday 9am-5pm (Pacific)</Typography>
            <Typography variant="subtitle1" className={classes.text}><strong>Mailing Address:</strong> 918 SW Yamhill St #301, Portland, OR 97205, USA</Typography>
            <Typography variant="subtitle1" className={classes.text}><strong>Phone:</strong> (503) 245-9886</Typography>
            <Typography variant="subtitle1" className={classes.text}><strong>Email:</strong> nia@nianow.com</Typography>
          </Paper>
        </div>
        <FooterSpacer />
      </main>
      <Footer />
    </div>
  );
};

ContactPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ContactPage);
